var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dp-solutions", attrs: { name: "dp-dispute-reports" } },
    [
      _c("div", { staticClass: "dp-solutions-container clearfix" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "solv-disputes hide col col-right col-last clearfix" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "discsol-list row" },
            _vm._l(_vm.disputes, function(dispute) {
              return _c(
                "div",
                { key: dispute.id, staticClass: "discsol-post-wrapper row" },
                [
                  _c("div", { staticClass: "discsol-post solution row" }, [
                    _c("div", { staticClass: "solution-main row" }, [
                      _c(
                        "div",
                        { staticClass: "solution-header with-actions row" },
                        [
                          _vm._m(1, true),
                          _vm._v(" "),
                          _c("div", { staticClass: "text" }, [
                            _vm._v("Reports")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "action" }, [
                            dispute.resolved
                              ? _c(
                                  "span",
                                  {
                                    class: [
                                      "resolved",
                                      { "is-useful": dispute.helpful_dispute }
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Resolved\n                "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "comment-content solution-content row" },
                        [
                          _c("div", { staticClass: "text" }, [
                            _c("div", {
                              domProps: { innerHTML: _vm._s(dispute.text) }
                            })
                          ])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._l(dispute.comments, function(comment) {
                    return _c(
                      "div",
                      {
                        key: comment.id,
                        staticClass:
                          "discsol-comments comment-wrapper hide-form row"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "discsol-comments-wrapper row" },
                          [
                            _c("a", { attrs: { name: "comments" } }),
                            _vm._v(" "),
                            _c("div", { staticClass: "disc-comments row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "cmmnt-container clearfix row solcomment"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "cmmnt clearfix row comment-item"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "comment-content row" },
                                        [
                                          _c("div", { staticClass: "text" }, [
                                            _c("div", {
                                              domProps: {
                                                innerHTML: _vm._s(comment.text)
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "meta" }, [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "mini-profile author"
                                                },
                                                [_vm._v(_vm._s(comment.user))]
                                              ),
                                              _vm._v(" "),
                                              comment.is_staff_comment
                                                ? _c(
                                                    "span",
                                                    { staticClass: "staff" },
                                                    [_vm._v("Staff")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "ts" },
                                                [
                                                  _vm._v(
                                                    " - " +
                                                      _vm._s(
                                                        _vm.timeAgo(comment.ts)
                                                      )
                                                  )
                                                ]
                                              )
                                            ])
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  })
                ],
                2
              )
            }),
            0
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "discsol-list-header row" }, [
      _c("h2", [_vm._v("Reports")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "avatar mini-profile" }, [
      _c("img", {
        attrs: {
          src:
            "https://ds055uzetaobb.cloudfront.net/site_media/images/default-avatar-globe.png",
          width: "45",
          height: "45"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }